import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { ConnectedTableLayout, ConnectedTable, TableProvider, HeaderTitle } from '@panwds/react-table'
import styled from 'styled-components'
import { Body } from '@panwds/react-ui'
import { loadTsgInstances } from '../../../common/utils/Sparky'
import appNames from '../common/appNames'
import { APP_ID_TO_NAME } from '../common/GlobalConstants'
import AppImage from './AppImage'
import { keyBy } from 'lodash'

type UInstanceTableProps = {
  id: string
  apps: any
}

const TableWrapper = styled.div`
  div[data-testid="connected-table-layout"] {
    height: 100% !important;
    max-height: 500px !important;
  }
   div[role="row"] {
    height: auto !important;
    padding-top:4px;
    padding-bottom:4px;
    border-right: 1px solid #DADBDB;
    border-left: 1px solid #DADBDB;
  }
  div[role="rowgroup"] {
    border-bottom: none;
  }
  div {
    min-height:0px !important;
  }
   svg {
      max-width: 5rem !important
   }
  padding-top:10px;
  `

const UInstanceTable = (props: UInstanceTableProps) => {
  const { id, apps } = props
  const keyByApps = keyBy(apps, 'app_id')
  const [loading, setLoading] = useState(true)
  const appName = useCallback((app_id) => {
    return appNames(apps).getAppName(app_id, '') === 'None' ? '' :
      appNames(apps).getAppName(app_id, APP_ID_TO_NAME[app_id])
  }, [apps])
  const AppIdRender = useCallback((row, value) => {
    return <div>
      <AppImage app_id={value} apps={keyByApps} alt={''} style={{ height: '20px', objectFit: 'contain', width: '20px' }} />
      {appName(value)}
    </div>
  }, [appName, keyByApps])
  const getDateFormat = (dateValue: any) => {
    if (dateValue) {
      const [year, month, day] = dateValue.split('-')
      return `${month}/${day.slice(0, 2)}/${year}`
    }
    return ''
  }
  const columns = useMemo(
    () => [
      {
        accessor: 'app_id',
        Header: 'Name',
        Cell: (props: any) => AppIdRender(props.row, props.value),
        width: 175 },
      {
        accessor: 'sku',
        Header: 'SKU',
        width: 175
      },
      {
        accessor: 'purchased_size',
        Header: 'License Units',
        width: 130
      },
      {
        accessor: 'license_expiration',
        Header: 'Expires at',
        Cell: (props: any) => getDateFormat(props.value),
      },
    ],
    [AppIdRender]
  )
  const [licenseDetails, setLicenseDetails] = useState<any>([])

  useEffect(() => {
    (async () => {
      setLoading(true)
      const instanceStoreResponse = await loadTsgInstances(id)
      setLicenseDetails(instanceStoreResponse?.map(each => {
        return {
          app_id: each.app_id,
          sku: each.sku,
          license_expiration: each.license_expiration,
          purchased_size: each.purchased_size ?? each?.extra?.purchased_size ?? 1
        }
      }))
      setLoading(false)
    })()
  }, [id])

  return <div style={{ width: '611px', height: '100px' }} className={'cm-bg-white'}>
    <TableWrapper>
      <TableProvider
        columns={columns}
        data={licenseDetails}
        enableColumnSort
        enableResizeColumns
        isLoading={loading}
      >
        <ConnectedTableLayout
          enableHeaderTitle={true}
          controlLeft={<HeaderTitle title={`Activated Product (${licenseDetails.length})`} />}
          sidecar={<div />}
          resultsSummary={<Body size='sm'>{`${licenseDetails?.length} results`}</Body>}
        >
          <ConnectedTable
            emptyStateProps={{
              heading: 'No Service Running',
            }}
          />
        </ConnectedTableLayout>
      </TableProvider>
    </TableWrapper>
  </div>
}

export default UInstanceTable
